import { useQuery } from 'react-query';
import { client } from 'utils/api-client';

export default function useFetchAllStaff(params) {
  return useQuery(['all-staff-attendance', params], (_, fieldParams) =>
    client('attendance', { params: fieldParams }).then((res) => res)
  );
}
